'use client';

import { Layout, Search, TrendingUp, Code2, Smartphone, ShieldCheck } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { useIsMobile } from '@/hooks/use-mobile';
import { m } from 'motion/react';

export default function Services() {
  const { t } = useLanguage();
  const isMobile = useIsMobile();

  const services = [
    {
      icon: Layout,
      title: t('services.corp.title'),
      description: t('services.corp.desc'),
    },
    {
      icon: Search,
      title: t('services.seo.title'),
      description: t('services.seo.desc'),
    },
    {
      icon: TrendingUp,
      title: t('services.ads.title'),
      description: t('services.ads.desc'),
    },
    {
      icon: Code2,
      title: t('services.apps.title'),
      description: t('services.apps.desc'),
    },
    {
      icon: Smartphone,
      title: t('services.mobile.title'),
      description: t('services.mobile.desc'),
    },
    {
      icon: ShieldCheck,
      title: t('services.security.title'),
      description: t('services.security.desc'),
    },
  ];

  return (
    <section id="services" className="py-24 bg-black relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <m.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-20"
        >
          <h2 className="text-3xl md:text-5xl font-semibold mb-6">
            {t('services.title.1')} <span className="text-[#19ffb5]">{t('services.title.2')}</span>
          </h2>
          <p className="text-gray-300 text-lg font-light">
            {t('services.description')}
          </p>
        </m.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <m.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -4 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group p-8 rounded-2xl bg-white/5 border border-white/10 hover:border-[#19ffb5]/40 transition-colors"
            >
              <div className="w-12 h-12 bg-[#006546]/15 rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#006546] transition-colors">
                <service.icon className="w-6 h-6 text-[#19ffb5] group-hover:text-white transition-colors" />
              </div>
              <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
              <p className="text-gray-300 leading-relaxed text-sm font-light">
                {service.description}
              </p>
            </m.div>
          ))}
        </div>
      </div>
    </section>
  );
}
